import React from "react";
import * as Yup from "yup";

import moment from "moment";
import { Col, Row } from "react-bootstrap";
import { Trans } from "react-i18next";
import { client } from "../../../App";
import {
  CaseMutationType,
  CaseStepperType,
  ContractStatusCodeEnum,
  PageForms,
  SelfReadingOperatorSearchType,
} from "../../../helpers/enums";
import { TranslatedText } from "../../../helpers/helpers";
import {
  CONSUMPTION_READING,
  getEvictionForMutation,
} from "../../../helpers/mutations";
import { LIST_CONTRACTS_WITH_FILTER_SMALL } from "../../../helpers/queries";
import { CaseFormField } from "../CaseGenerator";

const selfReadingComponent = (props) => {
  const { fields, layout } = props;
  const { fields: layoutFields } = layout;
  const layoutGriddedFields = layoutFields.slice(0, 7);

  return (
    <div key={layout.title} className={"selfReading-form-content-field"}>
      <h2 className="title">{layout.title}</h2>
      <Row>
        <div className="col-md-12 col-xs-12">
          <div className="form-group">
            <h2 className="case-step-title">
              <Trans i18nKey={"selfReading.form.header_container"} />
            </h2>
          </div>
        </div>
      </Row>
      <Row>
        {layoutGriddedFields.map((item, index) => {
          if (item.fieldName === "search_type") {
            const gridProps = item.grid;
            const fieldProps = fields[item.fieldName];

            return (
              <Col {...gridProps} key={index}>
                <CaseFormField {...fieldProps} />
              </Col>
            );
          } else {
            return null;
          }
        })}
      </Row>
      <Row>
        {layoutGriddedFields.map((item, index) => {
          if (item.fieldName !== "search_type") {
            const gridProps = item.grid;
            const fieldProps = fields[item.fieldName];

            return (
              <Col {...gridProps} key={index}>
                <CaseFormField {...fieldProps} />
              </Col>
            );
          } else {
            return null;
          }
        })}
      </Row>
    </div>
  );
};

const model = {
  formId: PageForms.SelfReadingOperator,
  formField: {
    search_type: {
      name: "search_type",
      label: <Trans i18nKey={"selfReading.form.search_type_label"} />,
      placeholder: (
        <Trans i18nKey={"selfReading.form.search_type_placeholder"} />
      ),
      requiredMessage: (
        <Trans i18nKey={"selfReading.form.search_type_required_message"} />
      ),
      type: "searchWithSelect",
      options: [
        {
          label: (
            <Trans
              i18nKey={"selfReading.form.search_type_option_client_code"}
            />
          ),
          value: SelfReadingOperatorSearchType.CLIENT_CODE,
        },
        {
          label: (
            <Trans
              i18nKey={"selfReading.form.search_type_option_contract_code"}
            />
          ),
          value: SelfReadingOperatorSearchType.CONTRACT_CODE,
        },
        {
          label: (
            <Trans i18nKey={"selfReading.form.search_type_option_puf_code"} />
          ),
          value: SelfReadingOperatorSearchType.PUF_CODE,
        },
        {
          label: (
            <Trans
              i18nKey={"selfReading.form.search_type_option_client_metre_code"}
            />
          ),
          value: SelfReadingOperatorSearchType.METRE_CODE,
        },
      ],
      relatedField: "contracts",
      onSearch: (
        name,
        type,
        nameForState,
        setStatus,
        search,
        setError,
        handleLoading
      ) => {
        handleLoading(true);
        client(true)
          .query({
            query: LIST_CONTRACTS_WITH_FILTER_SMALL,
            fetchPolicy: "network-only",
            variables: { listContractsReq: { [type]: search } },
          })
          .then((response) => {
            const { elements = [] } = response.data.listContracts;
            const data =
              elements === null
                ? []
                : elements.reduce((acc, curr) => {
                    const {
                      puf: { street, streetNumber, city, province, postalCode },
                      contractId,
                      integraClientCode,
                      integraContractCode,
                      status: { code },
                    } = curr;
                    acc.push({
                      id: contractId,
                      name: `${integraClientCode} - ${integraContractCode} ${street} ${streetNumber} ${city} ${province} ${postalCode}`,
                      state: ContractStatusCodeEnum[code] || "no_exist",
                      clientId: integraContractCode,
                      clientCode: integraClientCode,
                      street,
                      streetNumber,
                      city,
                      province,
                      postalCode,
                    });
                    return acc;
                  }, []);
            setStatus({ [nameForState]: data });
            if (data.length <= 0) {
              setError(<Trans i18nKey={"selfReading.form.no_results"} />);
            } else {
              setError(null);
            }
            handleLoading(false);
          })
          .catch((e) => {
            handleLoading(false);
            setError(<Trans i18nKey={"selfReading.form.genericError"} />);
            console.log(e);
          });
      },
    },
    contracts: {
      name: "contracts",
      label: <Trans i18nKey={"selfReading.form.contracts_label"} />,
      placeholder: <Trans i18nKey={"selfReading.form.contracts_placeholder"} />,
      requiredMessage: (
        <Trans i18nKey={"selfReading.form.contracts_required_message"} />
      ),
      loading: <TranslatedText i18nKey="cases.contract-select.loading" />,
      noContractFound: (
        <TranslatedText i18nKey="cases.contract-select.no-contract-found" />
      ),
      type: "selectWithRemoteOptions",
      excludeStatusTypes: [],
    },
    date: {
      name: "date",
      label: <Trans i18nKey={"selfReading.form.date"} />,
      placeholder: <Trans i18nKey={"selfReading.form.date_placeholder"} />,
      requiredMessage: (
        <Trans i18nKey={"selfReading.form.date_required_message"} />
      ),
      type: "date",
    },
    selfread: {
      name: "selfread",
      label: <Trans i18nKey={"selfReading.form.selfread_label"} />,
      placeholder: <Trans i18nKey={"selfReading.form.selfread_placeholder"} />,
      requiredMessage: (
        <Trans i18nKey={"selfReading.form.selfread_required_message"} />
      ),
      type: "input",
    },
  },
};

const {
  formField: { search_type, contracts, date, selfread },
} = model;

const initialValues = {
  [search_type.name]: SelfReadingOperatorSearchType.CLIENT_CODE,
  [date.name]: "",
  [contracts.name]: "",
  [selfread.name]: "",
};
//7444269
const getValidationSchema = () => {
  return [
    Yup.object().shape({
      search_type: Yup.string().required(search_type.requiredMessage),
      date: Yup.string().required(date.requiredMessage),
      selfread: Yup.string().required(selfread.requiredMessage),
      contracts: Yup.string().required(contracts.requiredMessage),
    }),
  ];
};

const layout = [
  {
    chapter: false,
    chapterName: "",
    title: "",
    fields: [
      {
        fieldName: search_type.name,
        grid: {
          xs: 12,
          md: 12,
        },
      },
      {
        fieldName: contracts.name,
        grid: {
          xs: 12,
          md: 4,
        },
      },
      {
        fieldName: date.name,
        grid: {
          xs: 12,
          md: 4,
        },
      },
      {
        fieldName: selfread.name,
        grid: {
          xs: 12,
          md: 4,
        },
      },
    ],
    component: selfReadingComponent,
  },
];

const formDetails = {
  title: <TranslatedText i18nKey={"autolettura.header"} />,
  stepper: CaseStepperType.None,
  backToText: <TranslatedText i18nKey="backToTextOperator" />,
  summary: false,
  successText: (
    <div>
      <Trans i18nKey={"selfReading.form.success"} />
    </div>
  ),
};
const mutation = {
  type: CaseMutationType.Custom,
  mutation: CONSUMPTION_READING,
  refetchQueries: getEvictionForMutation("consumptionReading"),
};
const translatedMapping = (payload) => {
  return {
    contractId: payload[contracts.name],
    reading: Number(payload[selfread.name]),
    date: moment(payload[date.name]).format("yyyy-MM-DD"),
  };
};
const translatedInverseMapping = (payload, values) => {
  const errorsFields = payload.map(({ field, key }) => {
    return { field, key };
  });
  const mapping = {
    "req.contractId": contracts.name,
    "req.date": date.name,
    "req.reading": selfread.name,
  };
  return errorsFields.reduce((acc, item) => {
    acc[mapping[item.field]] = (
      <Trans i18nKey={`selfReading.form.${item.field}.error.${item.key}`} />
    );
    return acc;
  }, {});
};
const main = () => {
  return {
    model,
    validationSchema: getValidationSchema(),
    initialValues,
    layout,
    formDetails,
    translatedMapping,
    translatedInverseMapping,
    mutation,
  };
};

export default main;
